var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgPurpleCirclewithtickIcon = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.5C10.336 2.5 2.5 10.336 2.5 20S10.336 37.5 20 37.5 37.5 29.664 37.5 20 29.664 2.5 20 2.5Zm0 32.031c-8.023 0-14.531-6.508-14.531-14.531S11.977 5.469 20 5.469 34.531 11.977 34.531 20 28.023 34.531 20 34.531Z",
    fill: "#2E2E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.469C11.977 5.469 5.469 11.977 5.469 20S11.977 34.531 20 34.531 34.531 28.023 34.531 20 28.023 5.469 20 5.469Zm7.555 8.816-8.227 11.406a1.242 1.242 0 0 1-2.02 0l-4.867-6.75a.314.314 0 0 1 .254-.496h1.832c.403 0 .778.196 1.012.52l2.781 3.86 6.14-8.516c.235-.329.614-.52 1.013-.52h1.832c.254 0 .402.29.25.496Z",
    fill: "#fff",
    fillOpacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.304 13.79h-1.832c-.398 0-.777.19-1.012.519l-6.14 8.515-2.781-3.86a1.25 1.25 0 0 0-1.012-.519h-1.832a.314.314 0 0 0-.254.496l4.867 6.75a1.242 1.242 0 0 0 2.02 0l8.226-11.406a.311.311 0 0 0-.25-.496Z",
    fill: "#2E2E2E"
  })));
};
export { SvgPurpleCirclewithtickIcon as ReactComponent };
export default __webpack_public_path__ + "b68099e9210c803cedf4493dc82c9188.svg";